import { Layout } from './layout.model';

export class DashboardLayout implements Layout {
  hasStatusBar: boolean = true;
  hasMenu: boolean = true;
  hasLayout: boolean = true;
  hasLayoutPadding = false;
  autoHideStatusBar = false;
}
